import React from "react";
import { ElementForm } from "../settingsForms/elementForm/elementForm/elementForm";
import { ElementFormActions } from "../settingsForms/elementForm/actions/elementFormActions";
import { ElementFormEditIcon } from "../settingsForms/elementForm/icons/elementFormEditIcon";
import { ElementFormDeleteIcon } from "../settingsForms/elementForm/icons/elementFormDeleteIcon";
import { VerticalSeparator } from "../settingsForms/separators/verticalSeparator/verticalSeparator";
import styles from "./rolesSettings.css";
import settingStyles from "../../../styles/settings.css";
import { intl } from "@fidget/common/i18n/TypedIntl";
import classNames from "classnames";
import { RoleForm } from "./types";
import { sortCaseInsensitiveAscPredicate } from "@fidget/common/utils/sort";

interface Props {
  roles: RoleForm[];
  onEdit: (role: RoleForm) => void;
  onDelete: (id: string) => void;
}

export const RoleList = ({ roles, onEdit, onDelete }: Props) => {
  const sortedRoles = roles.sort((a, b) => sortCaseInsensitiveAscPredicate(a.$.name.$, b.$.name.$));

  const renderElement = (role: RoleForm) => {
    return (
      <ElementForm key={role.$.id.$} className={styles.container}>
        <div className={styles.content}>
          <span className={classNames(settingStyles["form-label-font"], styles.flex)}>
            {intl.formatMessage("settings.rolesSettings.label")}
          </span>
          <span className={classNames(settingStyles["form-content-font"], styles.flex)}>
            {role.$.name.$}
          </span>
        </div>

        <VerticalSeparator style={"margin-around"} />
        <ElementFormActions>
          <ElementFormEditIcon onClick={() => onEdit(role)} />
          <ElementFormDeleteIcon onClick={() => onDelete(role.$.id.$)} />
        </ElementFormActions>
      </ElementForm>
    );
  };

  return <div>{sortedRoles.map(renderElement)}</div>;
};
